import React, { useMemo } from 'react'
import backIcon from './img/back.svg'
import logoIcon from 'static/img/fiton-care-logo.png'
import closeIcon from 'static/img/ic-close-header.svg'
import { useDarkMode } from 'hooks/useDarkMode'
import logoIconWhite from 'static/img/fiton-care-logo-white.svg'

const ContentHeader = (props) => {
  const {
    onBack,
    hideBack = false,
    showClose = false,
    onClose,
    showTopCorner = true,
  } = props
  const { isForcedDarkMode } = useDarkMode()

  const currentLogoIcon = useMemo(() => {
    return isForcedDarkMode ? logoIconWhite : logoIcon
  }, [isForcedDarkMode])

  return (
    <div
      className='content-header'
      style={
        showTopCorner
          ? { borderRadius: '24px 24px 0 0' }
          : { borderRadius: '0' }
      }
    >
      <img
        src={backIcon}
        alt=''
        className='back-icon'
        onClick={onBack}
        hidden={hideBack}
      />
      <img src={currentLogoIcon} alt='' className='logo-icon' />
      {showClose && (
        <img src={closeIcon} alt='' className='close-icon' onClick={onClose} />
      )}
    </div>
  )
}

export default ContentHeader
